import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { baseurl } from '../../helper/Baseurl';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from "../../context/TranslationContext"; 
import NoBooksMessage from '../../component/Book/NoBooksMessage';
import BooksGrid from '../../component/Book/BooksGrid';
import SearchAndSortBar from "../../component/SearchAndSortBar"; 
import Pagination from '../../component/Pagination';
import { FaSpinner } from 'react-icons/fa';
import noCoursesImage from "../../assets/images/png/Search.png"; 
const Allbooks = () => {
  const { translations , language } = useTranslation(); 
  const isArabic = language === "ar";

  const navigate = useNavigate();
  const [books, setBooks] = useState([]);
  const [likedBooks, setLikedBooks] = useState({});
  const [filteredBooks, setFilteredBooks] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOption, setSortOption] = useState("فرز حسب");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const booksPerPage = 8;
  const indexOfLastBook = currentPage * booksPerPage;
  const indexOfFirstBook = indexOfLastBook - booksPerPage;
  const currentBooks = filteredBooks.slice(indexOfFirstBook, indexOfLastBook);
  const totalPages = Math.ceil(filteredBooks.length / booksPerPage);

  const bookAvailabilityTranslations = {
    AVAILABLE_BOTH: translations.available,
    AVAILABLE_LIBRARY_ONLY: translations.available_library_only,
    AVAILABLE_ONLINE_ONLY: translations.available_online_only,
    RESERVED: translations.reserved,
    UNAVAILABLE: translations.unavailable
  };

  const showpicbooks = async (fileName) => `${baseurl}uploads/file/download/${fileName}`;

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const response = await axios.get(baseurl + "all-books", {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        const validBooks = response.data.filter(book =>
          ["AVAILABLE_ONLINE_ONLY", "AVAILABLE_BOTH"].includes(book.bookAvailability)
        );

        const booksData = await Promise.all(
          validBooks.map(async (book) => ({
            ...book,
            imageUrl: await showpicbooks(book.coverImageUrl),
            availabilityText: bookAvailabilityTranslations[book.bookAvailability] || "غير معروف",
          }))
        );

        const initialLikes = {};
        booksData.forEach(book => {
          initialLikes[book.id] = book.isFavorite;
        });

        setBooks(booksData);
        setFilteredBooks(booksData);
        setLikedBooks(initialLikes);
      } catch (error) {
        console.error("Error fetching books:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBooks();
  }, []);

  const handleLikeClick = async (id) => {
    try {
      const response = await axios.post(`${baseurl}toggle-favorite`, { type: "BOOK", id }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });
      if (response.data.isFavorite !== undefined) {
        setLikedBooks(prev => ({ ...prev, [id]: response.data.isFavorite }));
      }
    } catch (error) {
      console.error("Error toggling favorite:", error);
    }
  };

  const handleSortChange = (e) => setSortOption(e.target.value);

  useEffect(() => {
    let sorted = [...filteredBooks];
    if (sortOption === "الأحدث") {
      sorted.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
    } else if (sortOption === "الأعلى تقييمًا") {
      sorted.sort((a, b) => b.rating - a.rating);
    }
    setFilteredBooks(sorted);
  }, [sortOption]);

  useEffect(() => {
    const searchQuery = searchTerm.toLowerCase();
    setFilteredBooks(
      books.filter(book =>
        book.title.toLowerCase().includes(searchQuery) ||
        book.publisher.toLowerCase().includes(searchQuery)
      )
    );
  }, [searchTerm, books]);

  const handlePageChange = (page) => setCurrentPage(page);
  const openBookDetails = (id) => navigate(`/BookDetails/${id}`);

  const getAvailabilityStyle = (availability) => {
    switch (availability) {
      case 'AVAILABLE_BOTH':
        return { text: translations.available, bgColor: 'bg-green-600', btnText: translations.buy_now, btnDisabled: false };
      case 'AVAILABLE_LIBRARY_ONLY':
        return { text: translations.available_library_only, bgColor: 'bg-blue-500', btnText: translations.borrow_now, btnDisabled: false };
      case 'AVAILABLE_ONLINE_ONLY':
        return { text: translations.available_online_only, bgColor: 'bg-blue-500', btnText: translations.buy_now, btnDisabled: false };
      case 'RESERVED':
        return { text: translations.reserved, bgColor: 'bg-yellow-500', btnText: translations.borrow_now, btnDisabled: true };
      case 'UNAVAILABLE':
        return { text: translations.unavailable, bgColor: 'bg-red-500', btnText: translations.buy_now, btnDisabled: true };
      default:
        return { text: '', bgColor: '', btnText: '', btnDisabled: true };
    }
  };
  return (
<>
  {loading ? (
        <div className="flex items-center justify-center h-screen">
        <FaSpinner className="text-4xl animate-spin" />
      </div>
  ) : books.length === 0 ? (
    <NoBooksMessage translations={translations} noCoursesImage={noCoursesImage} />
  ) : (
    <div className="p-4">
      <SearchAndSortBar
        searchTerm={searchTerm}
        handleSearchChange={(e) => setSearchTerm(e.target.value)}
        sortOption={sortOption}
        handleSortChange={handleSortChange}
        translations={translations}
      />
      <BooksGrid
        books={currentBooks}
        likedBooks={likedBooks}
        handleLikeClick={handleLikeClick}
        openBookDetails={openBookDetails}
        getAvailabilityStyle={getAvailabilityStyle}
        translations={translations}
      />
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        handlePageChange={handlePageChange}
        isArabic={isArabic}
      />
      <ToastContainer />
    </div>
  )}
</>

  );
};

export default Allbooks;